import React from 'react';
import { Navigate } from 'react-router-dom';
import LoadingSpinner from '../components/global/LoadingSpinner';
import { useQuery } from '@tanstack/react-query';
import { getCurrentBusinessConfig } from '../firebase/firebase-delegate';
import { useAdminData } from '../contexts/AdminDataContext';
import { useTenant } from '../tenancy/TenantContext';
import { addTenantQueryToPath } from '../auth/adminAccess';

interface OwnerOnlyProps {
    element: JSX.Element;
}

const OwnerOnlyRoute: React.FC<OwnerOnlyProps> = ({ element }) => {
    const { tenantId } = useTenant();
    const { currentEmployeeQuery: employeeQuery } = useAdminData();

    const businessConfigQuery = useQuery({
        queryKey: ['businessConfig', tenantId],
        queryFn: () => getCurrentBusinessConfig(tenantId),
        enabled: employeeQuery.isSuccess
    });

    const isLoading = employeeQuery.isLoading || businessConfigQuery.isLoading;
    const isError = employeeQuery.isError || businessConfigQuery.isError;

    if (isLoading || businessConfigQuery.isLoading) {
        return <LoadingSpinner />;
    }

    const isOwner =
        businessConfigQuery.data?.paymentInfo?.owner === employeeQuery.data?.id;
    console.log("isOwner", isOwner, "owner: ", businessConfigQuery.data?.paymentInfo?.owner, "id: ", employeeQuery.data?.id);

    if (isError || !isOwner) {
        return <Navigate to={addTenantQueryToPath('/admin', tenantId)} replace />;
    }

    return element;
};

export default OwnerOnlyRoute;
